/**
 * Used to send message to other part of  applications, other controllers etc.
 * the message could be send with an event or modifiend some part of the parent scope
 */
(function() {
    angular.module('emarket.commons').factory('Announcer', ['$rootScope', function($rootScope) {
        var types = {
            FULL_SCREEN_MODE: 'navbar_fullscreen_mode',
            FULL_SCREEN_MODE_NO_TOOLBAR: 'navbar_fullscreen_mode_no_toolbar',
            HIDE_SEARCH_BAR: 'navbar_hide_search_bar',
            CHANGE_THEME_COLOR: 'address_bar_change_theme',
            SHOW_BACK_BUTTON: 'navbar_show_back_button',
            FILTER_PANEL_UPDATE: 'filter_panel_update',
            CHAT_MESSAGE_RECEIVER: 'chat_message_receiver',
            CHAT_MESSAGE: 'chat/messages',
            SEARCH_LOADING: 'search/loading'
        };
        return {
            createEmitter: function() {
                return {
                    emit: function() {
                        $rootScope.$emit.apply($rootScope, arguments);
                    }
                };
            },
            create: function(scope) {
                var events = [];
                var callbacks = {};
                var handler = function handler(e) {
                    callbacks[e.name].apply(null, arguments);
                };
                var communicate = {
                    /**
                 * Subscribe to an event
                 */
                    on: function(eventName, callback) {
                        callbacks[eventName] = callback;
                        var ev = $rootScope.$on(eventName, handler);
                        events.push(ev);
                        return ev;
                    },
                    emit: function() {
                        $rootScope.$emit.apply($rootScope, arguments);
                    }
                };
                if (scope) {
                    scope.$on('$destroy', function() {
                        events.forEach(function(event) {
                            event();
                        });
                    });
                }
                return communicate;
            },
            types: types
        };
    }]);
}());
